var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget"},[_vm._l((_vm.sections),function(section,index){return [_c('SLSections',{key:'section-' + index,attrs:{"index":index,"section":section}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }